import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import noop from 'lodash/noop'
import { EMPTY_ARRAY, EMPTY_OBJECT, validPhone } from '../../constants/globalConstants'
import CommonBtn from '../../components/global/CommonBtn'
import { Controller } from 'react-hook-form'
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask'
const phoneMaskGenerator = createDefaultMaskGenerator('(999) 999-9999')
import { globalKeyStore } from '../../redux/actions/globalState'
import Loader from '../../components/global/Loader'
import { getSessionDetails, getDefaultSession, getCardDataList } from '../../redux/actions/booking'
import { useEffect } from 'react'
import { isNetworkAvailable, isUserLoggedIn , validExpiryDate} from '../../utils/helper'
import useNetwork from '../../services/NetworkDetector'
import { Circles } from 'react-loader-spinner'
import { Button } from 'react-bootstrap'
const cardnumbermask = createDefaultMaskGenerator('9999 9999 9999 9999')
const expirymask = createDefaultMaskGenerator('99/99')
import moment from 'moment'

function PaymentBookingPage({
    dispatch,
    bookingFormDetail,
    errors,
    control,
    register,
    handleSubmit,
    getValues,
    bookingPromocode,
    sessionDetails,
    reset,
    userDetails,
    sessionError,
    sessionObj,
    selectEventType,
    eventandPassData,
    isLoading,
    setValue,
    isDirectBooking,
    nextFormStep,
    cardList,
    isCardFormVisible,
    notify,
    payment_profile_id,
    selectedFacilityId,
    fname,
    femail,
    fphone,
    fcard_pan,
    fcard_date_expiry_month,
    fcard_card_security_cvx_2
}) {
    // const monthListFormat = EXPIRY_MONTHS.map((item) => {return {'month_name':item, 'disable':false}})
    const [bookingShown, setbookingShown] = useState({ password: false, couponError: null })
    const [cardlidt, setCardList] = useState(false)
    // const [cardDetailsError, setCardDetailsError] = useState(false)
    // const [monthList, setMonthList] = useState(monthListFormat)
    const [cardExpiryMessage, setCardExpiryMessage] = useState('')
    const [cardExpiry, setCardExpiry] = useState('')
    // let localYear = new Date()
    const isOnline = useNetwork()

    useEffect(() => {
        const localDataPaymentSession = JSON.parse(localStorage.getItem('paymentSession'))
        if (localDataPaymentSession?.amount == 0) {
            dispatch(globalKeyStore({ isDirectBooking: true }))
        } else {
            dispatch(globalKeyStore({ isDirectBooking: false }))
        }
    }, EMPTY_ARRAY)

    useEffect(() => {
        reset(formValues => ({ ...formValues, email: userDetails?.email ? userDetails?.email : '', name: userDetails?.name ? userDetails?.name : '', phone: userDetails?.phone_number ? userDetails?.phone_number : '', }))
        const selLocalFacilityId = JSON.parse(localStorage?.getItem('selectedFacilityId'))
        if (selLocalFacilityId || selectedFacilityId) {
            const eventFacilityid = (selLocalFacilityId) ? selLocalFacilityId : selectedFacilityId
            dispatch(globalKeyStore({ selectedFacilityId: eventFacilityid }))

            if (eventFacilityid !== null) {
                if (isUserLoggedIn()) (
                    dispatch(getCardDataList(eventFacilityid)).then((res) => {
                        if (!res?.data?.payments?.length) {
                            notify('error', res?.errors?.message)
                        } else {
                            let selectedCard = res?.data?.payments?.filter((card) => card?.is_default == '1')
                            if(selectedCard?.length > 0) {
                                dispatch(globalKeyStore({ payment_profile_id: selectedCard[0]?.payment_profile_id, selectedCard: selectedCard[0] }))
                            }
                        }
                    }).catch((err) => {
                        notify('error', err?.message)
                    })
                )
            }
        }

        setTimeout(() => {
            dispatch(globalKeyStore({ ExpiryTimeSession: 0 }))
        }, 900000)
    }, [userDetails, isUserLoggedIn()])


    const handlCardExpiry = (value) => {
        let expiryDateCheck = validExpiryDate(value)
        if (value.length == 4 && !expiryDateCheck) {
            setCardExpiryMessage('Enter a valid expire date')
        } else {
            setCardExpiryMessage('')
            setCardExpiry(value?.trim())
            setValue('card_date_expiry_month', value.substring(0, 2))
            setValue('card_date_expiry_year', value.substring(2))
            setValue('expiration_date', value)
        }
    }

    // for coupon perpose 
    const applyCoupon = () => {
        let data = getValues()
        const { name, email, phone } = data
        let validEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i.test(data.email)
        if (!data.coupon) {
            setbookingShown({ ...bookingShown, couponError: 'Please enter a Promocode' })
        } else if (
            !data.name ||
            !validEmail ||
            !data.phone
        ) {
            setbookingShown({ ...bookingShown, couponError: 'Please enter valid user details' })
        } else {
            setbookingShown({ ...bookingShown, couponError: null })
            let sessionPayload = JSON.parse(JSON.stringify(sessionObj))
            sessionPayload.promocode = data.coupon
            sessionPayload.email = data.email
            sessionPayload.promo = data.email
            sessionPayload.license_plate = ''
            sessionPayload.phone = data.phone
            dispatch(globalKeyStore({ 'sessionDetails': { ...sessionDetails, promocode: false } }))
            const get_event_type = selectEventType == 'event' ? selectEventType : selectEventType == 'pass' ? localStorage.getItem('pass_type_slug') : ''
            const event_data = eventandPassData
            dispatch(getSessionDetails(sessionPayload)).then((res) => {
                if (res.data) {
                    const updatedDetails = {
                        ...bookingFormDetail,
                        personal_info: { name, email, phone },
                        payment_detail: null,
                        get_event_type: get_event_type,
                        event_data: event_data,
                        sessionDetails: res?.data
                    }
                    localStorage.setItem('bookingFormDetail', JSON.stringify(updatedDetails))
                    dispatch(globalKeyStore({ 'sessionDetails': { ...sessionDetails, data: res.data, coupon_code: data.coupon, promocode: true }, 'sessionError': null }))
                    if (res?.data?.amount == 0) {
                        dispatch(globalKeyStore({ isDirectBooking: true }))
                    } else {
                        dispatch(globalKeyStore({ isDirectBooking: false }))
                    }
                    localStorage.setItem('promo_applied', 1)
                } else {
                    dispatch(globalKeyStore({ 'sessionError': res?.errors }))
                    localStorage.setItem('couponApplied', 'Yes, but ' + res?.errors?.message)
                    setValue('coupon', '')
                    dispatch(getDefaultSession(sessionObj)).then((res) => {
                        dispatch(globalKeyStore({ 'sessionDetails': { ...sessionDetails, data: res.data, promocode: false, coupon_code: null } }))
                    }).catch((err) => {
                        console.log(err)
                    })
                }
            }).catch((err) => {
                console.log(err)
            })
            setbookingShown({ ...bookingShown, couponError: null })
        }
    }

    useEffect(() => {
        if(sessionDetails?.promocode && !sessionError) {
            handleCouponRemove()
        }
    }, [fname, femail, fphone])
    useEffect(() => {
        if(sessionDetails?.promocode && !sessionError) {
            dispatch(globalKeyStore({ 'sessionDetails': { ...sessionDetails, promocode: false } }))
        }
    }, [fcard_pan, fcard_date_expiry_month, fcard_card_security_cvx_2])


    const handleCouponRemove = () => {
        dispatch(globalKeyStore({ 'sessionDetails': { ...sessionDetails, promocode: false } }))
        dispatch(getDefaultSession(sessionObj)).then((res) => {
            dispatch(globalKeyStore({ 'sessionDetails': { ...sessionDetails, data: res.data, promocode: false, coupon_code: null } }))
            setValue('coupon', '')
            dispatch(globalKeyStore({ isDirectBooking: false }))
            localStorage.setItem('promo_applied', '')
            localStorage.setItem('coupon', '')
            localStorage.setItem('couponApplied', 'Yes, but removed')
        }).catch((err) => {
            console.log(err)
        })
    }

    // new function and for next step
    const handleNextStep = (data) => {
        const { name, email, phone, card_pan, card_card_security_cvx_2, card_date_expiry_month, card_date_expiry_year } = data
        if (isOnline) {
            if (isNetworkAvailable()) {
                // let curDate = new Date()
                // let thisMonth = new Date().getMonth() + 1
                // let thisYear = new Date().getFullYear()
                // let thisMonthYear = moment(thisMonth + '-01-' + thisYear).format('MM-DD-YYYY')
                // let cardMonthYear = moment(card_date_expiry_month + '-01-20' + card_date_expiry_year).format('MM-DD-YYYY')
                const currentDate = new Date(moment(new Date()).format('YYYY'), moment(new Date()).format('MM') - 1)
				const cardExpiry = new Date(moment(card_date_expiry_year, 'YY').format('YYYY'), card_date_expiry_month - 1)
                let checkDate = cardExpiry >= currentDate || isDirectBooking || payment_profile_id

                setCardList(true)
                if (
                    (name != '' && name != null && card_pan != '' && card_pan != null && (card_pan?.length >= 14 || card_pan?.length <= 16) && card_card_security_cvx_2 != '' && card_card_security_cvx_2 != null && (card_card_security_cvx_2?.length == 3 || card_card_security_cvx_2?.length == 4) && card_date_expiry_month != '' && card_date_expiry_month != null && card_date_expiry_year != '' && card_date_expiry_year != null && phone != '' && phone != null) ||
                    isDirectBooking ||
                    payment_profile_id
                ) {
                    const get_event_type = selectEventType == 'event' ? selectEventType : selectEventType == 'pass' ? localStorage.getItem('pass_type_slug') : ''
                    const event_data = eventandPassData
                    const updatedDetails = {
                        ...bookingFormDetail,
                        personal_info: { name, email, phone },
                        payment_detail: (isDirectBooking) ? null : { card_pan, card_card_security_cvx_2, card_date_expiry_month, card_date_expiry_year },
                        get_event_type: get_event_type,
                        event_data: event_data,
                        sessionDetails: sessionDetails,
                        user_consent: (data?.user_consent) ? '1' : '0',
                        payment_profile_id: payment_profile_id
                    }
                    setCardList(false)
                    localStorage.setItem('bookingFormDetail', JSON.stringify(updatedDetails))
                    
                    if (sessionDetails?.data?.amount == 0) {
                        nextFormStep()
                    } else if (checkDate) {
                        // setCardDetailsError(false)
                        nextFormStep()
                    } else {
                        // setCardDetailsError(true)
                    }
                }
            }
        }
    }

    const showCardForm = () => {
        dispatch(globalKeyStore({ isCardFormVisible: true, payment_profile_id: '' }))
        setCardList(false)
    }

    const hideCardForm = () => {
        dispatch(globalKeyStore({ isCardFormVisible: false, payment_profile_id: '' }))
        setCardList(false)
    }

    const handleCardSelectChange = (e) => {
        const { value } = e.target
        if (value) {
            let selectedCard = cardList?.filter((card) => card?.payment_profile_id == value)
            dispatch(globalKeyStore({ payment_profile_id: selectedCard[0]?.payment_profile_id, selectedCard: selectedCard[0] }))
        } else {
            dispatch(globalKeyStore({ payment_profile_id: '', selectedCard: {} }))
        }
        if(sessionDetails?.promocode && !sessionError) {
            dispatch(globalKeyStore({ 'sessionDetails': { ...sessionDetails, promocode: false } }))
        }

    }


    // const handleYearChange = (e) => {
    //     if(e.target.value == (localYear.getFullYear() % 100)) {
    //         let currMonth = localYear.getMonth()
    //         const monthFormat = EXPIRY_MONTHS.map((item, ind) => {
    //             if(ind < currMonth) {
    //                 return {'month_name':item, 'disable':true}
    //             }
    //             return {'month_name':item, 'disable':false}
    //         })
    //         setMonthList(monthFormat)
    //         setValue('card_date_expiry_month', '')
    //         console.log(currMonth, 'currMonth')
    //     } else {
    //         setMonthList(monthListFormat)
    //     }
    //     if(sessionDetails?.promocode && !sessionError) {
    //         dispatch(globalKeyStore({ 'sessionDetails': { ...sessionDetails, promocode: false } }))
    //     }
    // }

    const handleInputChange = () =>{
        if(localStorage.getItem('promo_applied') == 1){
            handleCouponRemove()
        }
    }

    return (
        <div>
            <form autoComplete='off'>
                {/* action={sessionDetails?.data?.api_url} className="border p-4" target="_top" name="ipg_form" method="post" */}
                <div className="row">
                    <div className="col-12 col-md-6 col-sm-8">
                        <div className="d-flex"><label className="mb-3"><b>Personal Information</b></label></div>
                        <div className="row">
                            <div className="col-12 mb-2">
                                <input type="text" className="form-control" disabled={isUserLoggedIn() ? true : false} name='name' id="name" placeholder="Name" {...register('name', { required: true })} />
                                {errors?.name?.type === 'required' && <span style={{ color: 'red' }}>This field is required</span>}
                            </div>
                            <div className="col-sm-6 col-12 mb-2">
                                <input type="email" name='email' disabled={isUserLoggedIn() ? true : false} onChange={() => handleInputChange()} className="form-control" maxLength='40' minLength='1' placeholder="Email Address"
                                    {...register('email', {
                                        pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, message: 'invalid email address' }
                                    })}
                                />
                                {errors?.email && <>
                                    {errors.email.type === 'required' && <span style={{ color: 'red' }}>This field is required</span>}
                                    {errors.email.type === 'pattern' && <span style={{ color: 'red' }}>{errors?.email?.message}</span>}
                                </>}
                            </div>
                            <div className="col-12 col-sm-6 mb-2">
                                <Controller
                                    name="phone"
                                    type="text"
                                    id="phone"
                                    control={control}
                                        rules={{ 
                                            required: {
                                                value: true,
                                                message: 'This field is required',
                                              },
                                              pattern: {
                                                value: validPhone,
                                                message: 'Please enter a valid phone number',
                                              },
                                         }}
                                    onChange={() => handleInputChange()}
                                    render={({ field }) => <MaskedInput
                                        maskGenerator={phoneMaskGenerator}
                                        className="form-control"
                                        {...field}
                                        disabled={isUserLoggedIn() ? true : false}
                                        maxLength={14}
                                        minLength={10}
                                        title="Please enter a valid phone number"
                                        onInvalid={e => e.target.setCustomValidity('Please enter phone number')}
                                        onInput={e => e.target.setCustomValidity('')}
                                        placeholder="Phone Number"
                                    />}
                                />
                                {errors?.phone?.type === 'required' && <span style={{ color: 'red' }}>This field is required</span>}
                                {errors?.phone?.type === 'pattern' && <span style={{ color: 'red' }}>Please enter a valid phone number</span>}
                            </div>
                        </div>

                        <div className="row">
                            <label className="mb-3 col-12 "><b>Apply Coupon</b></label>
                            <div className="row">
                                <div className="col">
                                    <div className="input-group">
                                        {/* <CustomInput */}
                                        <input
                                            type="text"
                                            name="coupon"
                                            className="form-control"
                                            placeholder="Enter Your Coupon Code"
                                            aria-label="coupon"
                                            aria-describedby="basic-addon1"
                                            {...register('coupon', {
                                                onChange: (e) => { localStorage.setItem('coupon', e.target.value) }
                                            })}
                                        />
                                        {sessionDetails?.promocode && !sessionError && <span className="cursor input-group-text" role='button' id="basic-addon1" onClick={handleCouponRemove}>X</span>}
                                        {!bookingShown?.couponError && sessionError?.message && <span style={{ color: 'red', width: '100%' }}>{sessionError?.message}</span>}
                                        {bookingShown?.couponError && <span style={{ color: 'red', width: '100%' }}>{bookingShown?.couponError}</span>}
                                        {sessionDetails?.promocode && !sessionError && !bookingShown?.couponError && <span style={{ color: 'green', width: '100%' }}>Coupon Code Applied Successfully!</span>}
                                    </div>
                                </div>
                                <div className="col-auto">
                                    <CommonBtn className="btn btn-primary" value='Apply' disabled={(bookingPromocode?.loader) ? true : false} onClick={applyCoupon} />
                                </div>
                                {bookingPromocode?.loader && <div className='d-flex justify-item-start align-items-center mt-2'><Loader width='24' height='24' /> &nbsp;&nbsp;Loading...</div>}
                                <span className="promo-msg "><span className="text-danger"></span></span>
                            </div>
                        </div>

                    </div>
                    {sessionDetails?.data?.amount == 0 ? '' :
                        <div className="col-12 col-md-6 col-sm-8 mt-2 mt-md-0">
                            <div className="d-flex"><label className="mb-3"><b>Payment Details</b></label></div>
                            {(isUserLoggedIn() && (cardList?.length > 0)) && <div className='row'>
                                {(cardList?.length > 0) && <div className="col-sm-6">
                                    <div className="mb-3">
                                        <select name="vehicle" id="vehicle" disabled={isCardFormVisible} className="form-select" onChange={handleCardSelectChange} >
                                            <option>Select Card</option>
                                            {cardList?.map((card, index) => {
                                                return (
                                                    <option value={card?.payment_profile_id} selected={card?.payment_profile_id == payment_profile_id} key={index}>{`XXXX XXXX XXXX ${card?.card_last_four?.slice(0, 4)} (${card?.expiry?.slice(0, 2)}${card?.expiry?.slice(2, 4)})`}</option>
                                                )
                                            })}
                                        </select>
                                        {cardlidt && <span className="form-text text-danger h-40">{(payment_profile_id == '' || !payment_profile_id) ? 'Please select or add new card' : ''}</span>}
                                    </div>
                                </div>}

                                {(cardList?.length > 0) && !isCardFormVisible ? <div className='col-12 col-md-6 col-sm-8'>{(cardList?.length > 0) && <span className='badge badge-primary text-dark fw-bold me-2'>OR</span>}
                                    <button className='btn btn-primary' type="button" onClick={showCardForm}><i className='fa fa-plus'></i> Add New Card</button></div>
                                    : (cardList?.length > 0) && <div className='col-sm-6'><span className='badge badge-primary text-dark fw-bold me-2'>OR</span>
                                        <button className='btn btn-danger' type="button" onClick={hideCardForm}>Select Existing Card</button>
                                    </div>}
                            </div>}

                            <div className='row'>
                                {/* payment gate-way of booking event's */}
                                {(cardList?.length < 1 || isCardFormVisible) && <div className="col-12">
                                    <div className="mb-2">
                                        <Controller
                                            name="card_pan"
                                            type="text"
                                            id="card_pan"
                                            control={control}
                                            inputmode="numeric"
                                            rules={{
                                                pattern: { value: /[0-9]*$/, message: 'Please enter a valid Card Number' },
                                                required: { value: (isDirectBooking) ? false : true, message: 'This field is required' },
                                                minLength: { value: 14, message: 'Please enter a valid Card Number' },
                                                maxLength: { value: 16, message: 'Please enter a valid Card Number' },
                                            }}

                                            render={({ field }) => <span className='cardNumberCardImage d-block'> <MaskedInput
                                                maskGenerator={cardnumbermask}
                                                autoComplete="off"
                                                inputmode="numeric"
                                                maxLength='19'
                                                {...field}
                                                id="card_pan"
                                                className="form-control"
                                                placeholder="Enter Card Number"
                                            /></span>}
                                        />
                                        {errors?.card_pan && <>
                                            {errors?.card_pan?.type === 'required' && <span style={{ color: 'red' }}>This field is required</span>}
                                            {errors?.card_pan?.type === 'pattern' && <span style={{ color: 'red' }}>{errors?.card_pan?.message}</span>}
                                            {errors?.card_pan?.type === 'minLength' && <span style={{ color: 'red' }}>{errors?.card_pan?.message}</span>}
                                            {errors?.card_pan?.type === 'maxLength' && <span style={{ color: 'red' }}>{errors?.card_pan?.message}</span>}
                                        </>}
                                    </div>
                                    <div className="row">
                                        {/* <div className="col-sm-4 col-6 mb-2">
                                            <select
                                                name="card_date_expiry_year"
                                                id="expiryYear"
                                                required
                                                className="form-select"
                                                {...register('card_date_expiry_year', {
                                                    required: (isDirectBooking) ? false : true
                                                })}
                                                onChange={(e) => handleYearChange(e)}
                                            >
                                                <option value=''>Expiry Year</option>
                                                {EXPIRY_YEARS?.map((item, key) => <option key={key} value={item.val}>{item.label}</option>)}
                                            </select>
                                            {errors?.card_date_expiry_year?.type === 'required' && <span style={{ color: 'red' }}>This field is required</span>}
                                        </div>
                                        <div className="col-sm-4 col-6 mb-2">
                                            <select
                                                name="card_date_expiry_month"
                                                id="card_date_expiry_month"
                                                required
                                                className="form-select"
                                                {...register('card_date_expiry_month', {
                                                    required: (isDirectBooking) ? false : true
                                                })}
                                            >
                                                <option value=''>Expiry Month</option>
                                                {monthList?.map((item, key) => <option disabled={item.disable} key={key} value={item.month_name}>{item.month_name}</option>)}
                                            </select>
                                            {errors?.card_date_expiry_month?.type === 'required' && <span style={{ color: 'red' }}>This field is required</span>}
                                        </div> */}
                                           <div className="col-sm-6 col-md-6">
                                            <div>
                                                <Controller
                                                    name="expiration_date"
                                                    type="number"
                                                    id="standardCardExpiration"
                                                    inputmode="numeric"
                                                    control={control}
                                                    rules={{ required: true }}
                                                    render={({ field }) => <MaskedInput
                                                        maskGenerator={expirymask}
                                                        autoComplete="off"
                                                        inputmode="numeric"
                                                        maxLength='5'
                                                        id="standardCardExpiration"
                                                        {...field}
                                                        onChange={(e) => { field.onChange(e); handlCardExpiry(e) }}
                                                        value={cardExpiry}
                                                        className="form-control"
                                                        placeholder="MM/YY"
                                                    />}
                                                />
                                                {errors?.expiration_date?.type === 'required' && <span style={{ color: 'red' }} >This field is required</span>}
                                                {<span style={{ color: 'red' }}>{cardExpiryMessage}</span>}
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="input-group mb-2">
                                                <input
                                                    type={bookingShown.password ? 'text' : 'password'}
                                                    className="form-control"
                                                    id="card_card_security_cvx_2"
                                                    required
                                                    maxLength="4"
                                                    minLength="3"
                                                    inputMode="numeric"
                                                    name="card_card_security_cvx_2"
                                                    placeholder="CVV"
                                                    autoComplete="new-password"
                                                    {...register('card_card_security_cvx_2', {
                                                        required: (isDirectBooking) ? false : true,
                                                        pattern: { value: /^[0-9, a-z, A-Z ]{3,4}$/i, message: 'invalid CVV' }
                                                    })}
                                                />
                                                <span className="cursor input-group-text" role="button" id="basic-addon1" onClick={() => setbookingShown({ ...bookingShown, password: !bookingShown.password })}> <i className={bookingShown.password ? 'fas fa-eye-slash' : 'fas fa-eye'}></i></span>
                                                {errors?.card_card_security_cvx_2 && <div style={{ width: '100%' }}>
                                                    {errors?.card_card_security_cvx_2?.type === 'required' && <span style={{ color: 'red' }}>This field is required</span>}
                                                    {errors?.card_card_security_cvx_2?.type === 'pattern' && <span style={{ color: 'red' }}>{errors?.card_card_security_cvx_2?.message}</span>}
                                                </div>}
                                            </div>
                                        </div>
                                        <span className="text-danger cvvError mb-2"><b></b></span>
                                    </div>
                                    {/* {cardDetailsError && <span style={{ color: 'red' }}>Please enter a valid card detail</span>} */}
                                    <input type='hidden' name='XXX_IPG_XXX' id='XXX_IPG_XXX' value='confirm' />
                                    <input type='hidden' name='XXX_IPGTRXNO_XXX' id='XXX_IPGTRXNO_XXX' value={sessionDetails?.data?.guid} />
                                    <input type='hidden' name='XXX_IPGSESSION_XXX' id='XXX_IPGSESSION_XXX' value={sessionDetails?.data?.ipgSession}></input>

                                </div>}
                            </div>

                            {(cardList?.length < 1 || isCardFormVisible) && (isUserLoggedIn()) && <div className='row'>
                                <div className="col-12 ">
                                    <div className="form-check">
                                        <input className="form-check-input" name='user_consent' type="checkbox" value="" id="flexCheckDefault"  {...register('user_consent')} />
                                        <label className="form-check-label" htmlFor="flexCheckDefault">
                                            Save the card
                                        </label>
                                    </div>
                                </div>
                            </div>}
                        </div>}
                </div>
                <div className="row">
                    <span className="text-danger mt-4"><b></b></span>
                    <div className="col-md-2 col-4">
                        <div className="mb-3">
                            <Button variant="primary" type='submit' className="btn btn-danger btn-lg w-100" onClick={handleSubmit(handleNextStep)}>
                                <div className='d-flex justify-content-center align-items-center' disabled={(isLoading) ? true : false}>
                                    <span>Book </span>  <span className='ms-2'>
                                        {isLoading ? <Circles
                                            height="20"
                                            width="20"
                                            style={{ display: 'inline-block' }}
                                            color="#ffffff"
                                            ariaLabel="circles-loading"
                                            visible={true}
                                        /> : null}
                                    </span>
                                </div>
                            </Button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
}

PaymentBookingPage.propTypes = {
    dispatch: PropTypes.func,
    notify: PropTypes.func,
    bookingFormPage: PropTypes.number,
    bookingFormDetail: PropTypes.object,
    nextFormStep: PropTypes.func,
    errors: PropTypes.object,
    control: PropTypes.func,
    register: PropTypes.func,
    handleSubmit: PropTypes.func,
    getValues: PropTypes.func,
    setValue: PropTypes.func,
    bookingPromocode: PropTypes.object,
    sessionDetails: PropTypes.object,
    sessionObj: PropTypes.object,
    sessionError: PropTypes.object,
    reset: PropTypes.func,
    userDetails: PropTypes.object,
    ExpiryTimeSession: PropTypes.number,
    eventandPassData: PropTypes.object,
    selectEventType: PropTypes.string,
    isLoading: PropTypes?.bool,
    isDirectBooking: PropTypes.bool,
    cardList: PropTypes.array,
    isCardFormVisible: PropTypes.bool,
    payment_profile_id: PropTypes.string,
    selectedFacilityId: PropTypes.string,
    fname: PropTypes.string,
    femail: PropTypes.string,
    fphone: PropTypes.string,
    fcard_pan: PropTypes.string,
    fcard_date_expiry_month: PropTypes.string,
    fcard_card_security_cvx_2: PropTypes.string
}

PaymentBookingPage.defaulProps = {
    dispatch: noop,
    notify: noop,
    bookingFormPage: 1,
    bookingFormDetail: EMPTY_OBJECT,
    nextFormStep: noop,
    errors: EMPTY_OBJECT,
    control: noop,
    register: noop,
    handleSubmit: noop,
    getValues: noop,
    setValue: noop,
    bookingPromocode: EMPTY_OBJECT,
    sessionDetails: EMPTY_OBJECT,
    sessionObj: EMPTY_OBJECT,
    sessionError: EMPTY_OBJECT,
    reset: noop,
    userDetails: EMPTY_OBJECT,
    ExpiryTimeSession: 0,
    eventandPassData: EMPTY_OBJECT,
    selectEventType: '',
    isLoading: false,
    isDirectBooking: false,
    cardList: EMPTY_ARRAY,
    isCardFormVisible: false,
    payment_profile_id: '',
    selectedFacilityId: '',
    fname: '',
    femail: '',
    fphone: '',
    fcard_pan: '',
    fcard_date_expiry_month: '',
    fcard_card_security_cvx_2: ''
}


function mapStateToProps({ globalReducers, bookingReducer, loginReducer }) {
    return {
        selectedPassType: globalReducers?.selectedPassType,
        bookingFormPage: globalReducers?.bookingFormPage,
        bookingFormDetail: globalReducers?.bookingFormDetail,
        bookingPromocode: bookingReducer,
        sessionDetails: globalReducers?.sessionDetails,
        sessionError: globalReducers?.sessionError,
        userDetails: (Object.keys(globalReducers?.userDetails).length > 0) ? globalReducers?.userDetails : loginReducer?.data?.data?.user,
        ExpiryTimeSession: globalReducers?.ExpiryTimeSession,
        eventandPassData: (globalReducers?.selectEventType == 'pass') ? globalReducers?.passData : globalReducers?.eventData?.[0],
        selectEventType: globalReducers?.selectEventType,
        isLoading: bookingReducer?.loader,
        couponFilled: bookingReducer?.data?.couponFilled,
        coupon_code: bookingReducer?.data?.coupon,
        couponApplied: bookingReducer?.data?.coupon,
        isDirectBooking: globalReducers?.isDirectBooking,
        cardList: (bookingReducer?.cardDetails?.length) ? bookingReducer?.cardDetails : EMPTY_ARRAY,
        payment_profile_id: globalReducers?.payment_profile_id,
        isCardFormVisible: (globalReducers?.isCardFormVisible) ? globalReducers?.isCardFormVisible : '',
        selectedFacilityId: globalReducers?.selectedFacilityId
    }
}

export default connect(mapStateToProps)(PaymentBookingPage)